import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from 'ac-ui-core-local';
import { DashboardComponent } from 'app/dashboard/dashboard.component';

const routes: Routes = [
	{
		path: '',
		component: DashboardComponent,
		canActivate: [AuthGuard],
		data: { title: 'Dashboard | AmazingCo.' }
	},
	{
		path: 'users',
		loadChildren: './users/users.module#UsersModule'
	},
	{
		path: 'events',
		loadChildren: './events/events.module#EventsModule',
		canActivate: [AuthGuard],
		data: { title: 'Events | AmazingCo.' }
	},
	{
		path: 'planner',
		loadChildren: './planner/planner.module#PlannerModule',
		canActivate: [AuthGuard]
	},
	{
		path: 'activities',
		loadChildren: './activities/activities.module#ActivitiesModule',
		canActivate: [AuthGuard]
	},
	{
		path: 'customers',
		loadChildren: './customers/customers.module#CustomersModule',
		canActivate: [AuthGuard],
		data: { title: 'Customers | AmazingCo.' }
	},
	{
		path: 'providers',
		loadChildren: './providers/providers.module#ProvidersModule',
		canActivate: [AuthGuard],
		data: { title: 'Providers | AmazingCo.' }
	},
	{
		path: 'settings',
		loadChildren: './settings/settings.module#SettingsModule',
		canActivate: [AuthGuard],
		data: { title: 'Settings | AmazingCo.' }
	},
	{
		path: 'fulfilment',
		loadChildren: './fulfilment/fulfilment.module#FulfilmentModule',
		canActivate: [AuthGuard],
		data: { title: 'Fulfilment | AmazingCo.' }
	},
	{
		path: 'gift-cards',
		loadChildren: './gift-cards/gift-cards.module#GiftCardsModule',
		canActivate: [AuthGuard],
		data: { title: 'Gift Cards | AmazingCo.' }
	}
];

@NgModule({
	imports: [RouterModule.forRoot(routes)],
	exports: [RouterModule]
})
export class AppRoutingModule { }
